import { FC, useState } from 'react'
import { useUserProfileContext } from '../../../../context/UserProfileContext'
import { sanitizeHtml } from '../../../../helpers/sanitizeHtml'

const CHARACTER_LIMIT = 400

const BiographyTab: FC = () => {
  const [isExpanded, setIsExpanded] = useState(false)
  const { data } = useUserProfileContext()


  const biography = sanitizeHtml(data?.biography)

  const toggleExpanded = () => {
    setIsExpanded(!isExpanded)
  }

  if (!biography) {
    return (
      <div className='bio-tabs__panel' >
        <div className='bio-tabs__text'>
          <p>No biography available.</p>
        </div>
      </div>
    )
  }

  return (
    <div className='bio-tabs__panel'>
      <div className='bio-tabs__text'>
        <div className={`w-100 biography-text-content ${isExpanded ? '' : 'truncated-biography'}`} dangerouslySetInnerHTML={{ __html: biography }}>
        </div>
        <div className='bio-tabs__readmore mb-15 w-100' onClick={toggleExpanded}>
          {isExpanded ? 'Read less' : 'Read more'}
        </div>
      </div>
      <div className='bio-gallery-section'>
        <div className='bio-tabs__gallery'>
          {data?.videos &&
            data?.videos.map((video) => {
              const videoId = video.videoLink.split('v=')[1]?.split('&')[0]
              if(!videoId) return null;
              return (
                <div key={video.id} className='bio-tabs__video mr_4' style={{ position: 'relative' }}>
                  <iframe
                    src={`https://www.youtube.com/embed/${videoId}?controls=0&showinfo=0&modestbranding=1`}
                    frameBorder='0'
                    allow='accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
                    allowFullScreen
                  />
                  <div
                    onClick={() => {
                      window.open(video.videoLink, '_blank')
                    }}
                    style={{
                      position: 'absolute',
                      top: 0,
                      left: 0,
                      width: '100%',
                      height: '100%',
                      cursor: 'pointer',
                      zIndex: 1,
                    }}
                  />
                </div>
              )
            })}
        </div>
      </div>
    </div>
  )
}

export { BiographyTab }